import React, { useState, useEffect } from 'react';

import { SupportStyle } from './SupportStyle';

import PageWithMenu from '../../components/PageWithMenu/PageWithMenu';
import Header from '../../components/Header/Header';
import SnackBar from '../../components/SnackBar/SnackBar';

import SendHelpEmailForm from '../../components/SendHelpEmailForm/SendHelpEmailForm';

import EmailIcon from '../../assets/svgs/EmailIcon';
import PhoneIcon from '../../assets/svgs/PhoneIcon';
import LocationIcon from '../../assets/svgs/LocationIcon';
import Loading from '../../components/Loading/Loading';

import { useBreakpoint } from '../../utils/useBreakpoint';
import { breakpoints } from '../../ui/variables';
import { headerVariables } from '../../components/Header/HeaderStyle';

const Support = () => {
  const breakpoint = useBreakpoint();

  const [showMenu, setShowMenu] = useState(false);
  const [actionComplete, setActionComplete] = useState({});
  const [pageWithMenuStyle] = useState({
    paddingTop: `${headerVariables.main.height.iphone + 52}px`,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!loading) {
      const timeout = setTimeout(() => {
        setActionComplete(null);
      }, 3000);

      return () => clearTimeout(timeout);
    }

    return null;
  }, [loading]);

  const handleShowMenu = () => setShowMenu(!showMenu);
  return (
    <PageWithMenu showMenu={showMenu} menuStyle={pageWithMenuStyle}>
      <SupportStyle>
        <Header
          handleShowMenu={
            breakpoint.width < breakpoints.ipadLandscape.width
              ? handleShowMenu
              : null
          }
        />

        {actionComplete?.type ? (
          <div className="snack-bar-wrapper">
            <SnackBar type={actionComplete.type} text={actionComplete.text} />
          </div>
        ) : null}

        <div className="contact-info">
          <span className="contact-box-title">Contact</span>
          <div className="email-container">
            <EmailIcon className="email-icon" />
            <span className="link-info">contato@petrec.com.br</span>
          </div>
          <div className="phone-container">
            <PhoneIcon />
            <div className="phone-number-container">
              <span className="link-info">+55 (21) 3733-1816</span>
              <span className="link-info">+55 (21) 3733-1817</span>
            </div>
          </div>
          <div className="address-container">
            <LocationIcon />
            <span className="text-address">
              Rua Aloísio Teixeira, 278 - Prédio 3. Sala 106. CE-TIC - Cidade
              Universitária, Rio de Janeiro – RJ CEP: 21.941-850
            </span>
          </div>
        </div>
        <SendHelpEmailForm
          loading={loading}
          setLoading={setLoading}
          setActionComplete={setActionComplete}
        />
      </SupportStyle>
      {loading ? <Loading /> : null}
    </PageWithMenu>
  );
};

export default Support;
